<template>
    <table class="table table-responsive vita">
        <tbody v-for="info in infos" :key="info.id">
            <tr>
                <td width="15%">
                    <span>{{info.pa_zeit}}</span>
                </td>
                <td>
                    <span style="font-weight:bold;" v-if="(info.pa_ueberschrift !== '')" v-html="filterHtml(info.pa_ueberschrift)"></span>
                    <br v-if="(info.pa_ueberschrift !== '')"/>
                    <span v-html="filterHtml(info.pa_text)"></span>
                </td>   
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        'infos' : Array
    },
    methods: {
        filterHtml(html) {
            //console.log(html);
            var regex = new RegExp('<br />', 'g');
            var result = html.replace(regex, '<br/><br/>');

            regex = new RegExp('<br>', 'g');
            result = result.replace(regex, '<br/><br/>');

            regex = new RegExp('&lt;br /&gt;', 'g');
            result = result.replace(regex, '<br/><br/>');

            regex = new RegExp('&lt;br &gt;', 'g');
            result = result.replace(regex, '<br/><br/>');

            regex = new RegExp('<br/><br/><br/><br/>', 'g');
            result = result.replace(regex, '<br/><br/>');

            regex = new RegExp('<br/><br/><br/>', 'g');
            result = result.replace(regex, '<br/><br/>');

            regex = new RegExp('\n', 'g');
            result = result.replace(regex, '<br/>');

            //console.log(result);  
            return result;    
/*            var result = html.replace("<br />", "\n");
            result = result.replace("<br/>", "\n");
            result = result.replace("&lt;br /&gt;", "\n");   
            return result; */  
        }
    }
}
</script>

<style scoped>
    .table.vita tr>td {
        font-size:1.1rem;
        line-height:1.2rem;
        padding:6px 6px;
    }
    @media (max-width: 575px) {
        .table.vita tr>td {
            font-size:1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/PeopleInfo.vue